// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 'navigation',
    title: 'MENU',
    type: 'break',
    path: '',
    active: [''],
    children: [
      {
        id: 'home',
        title: 'common:navigation.home.title',
        type: 'menu',
        path: 'common:navigation.home.path',
        active: ['/'],
        children: [],
        permissions: [],
      },
      {
        id: 'investment',
        title: 'common:navigation.investment.title',
        type: 'menu',
        path: '',
        active: [
          'common:navigation.investment.incentive.path',
          'common:navigation.investment.distribution.path',
          'common:navigation.investment.propose.path',
        ],
        children: [
          {
            id: 'whyInvest',
            title: 'common:navigation.investment.whyInvest.title',
            type: 'menu',
            path: 'common:navigation.investment.whyInvest.path',
            active: ['common:navigation.investment.whyInvest.path'],
            permissions: [],
          },
          {
            id: 'incentive',
            title: 'common:navigation.investment.incentive.title',
            type: 'menu',
            path: 'common:navigation.investment.incentive.path',
            active: ['common:navigation.investment.incentive.path'],
            permissions: [],
          },
          {
            id: 'distribution',
            title: 'common:navigation.investment.distribution.title',
            type: 'menu',
            path: 'common:navigation.investment.distribution.path',
            active: ['common:navigation.investment.distribution.path'],
            permissions: [],
          },
          {
            id: 'propose',
            title: 'common:navigation.investment.propose.title',
            type: 'menu',
            path: 'common:navigation.investment.propose.path',
            active: ['common:navigation.investment.propose.path'],
            permissions: [],
          },
        ],
        permissions: [],
      },
      {
        id: 'about',
        title: 'common:navigation.about.title',
        type: 'menu',
        path: '',
        active: [
          'common:navigation.about.general.path',
          'common:navigation.about.nationalCouncil.path',
          'common:navigation.about.secretariatGeneral.path',
          'common:navigation.about.implementationTeam.path',
          'common:navigation.about.administrator.path',
        ],
        children: [
          {
            id: 'general',
            title: 'common:navigation.about.general.title',
            type: 'menu',
            path: 'common:navigation.about.general.path',
            active: ['common:navigation.about.general.path'],
            permissions: [],
          },
          {
            id: 'nationalCouncil',
            title: 'common:navigation.about.nationalCouncil.title',
            type: 'menu',
            path: 'common:navigation.about.nationalCouncil.path',
            active: ['common:navigation.about.nationalCouncil.path'],
            permissions: [],
          },
          {
            id: 'secretariatGeneral',
            title: 'common:navigation.about.secretariatGeneral.title',
            type: 'menu',
            path: 'common:navigation.about.secretariatGeneral.path',
            active: ['common:navigation.about.secretariatGeneral.path'],
            permissions: [],
          },
          {
            id: 'implementationTeam',
            title: 'common:navigation.about.implementationTeam.title',
            type: 'menu',
            path: 'common:navigation.about.implementationTeam.path',
            active: ['common:navigation.about.implementationTeam.path'],
            permissions: [],
          },
          {
            id: 'administrator',
            title: 'common:navigation.about.administrator.title',
            type: 'menu',
            path: 'common:navigation.about.administrator.path',
            active: ['common:navigation.about.administrator.path'],
            permissions: [],
          },
        ],
        permissions: [],
      },
      {
        id: 'media',
        title: 'common:navigation.media.title',
        type: 'menu',
        path: '',
        active: ['common:navigation.media.incentive.path', 'common:navigation.media.distribution.path'],
        children: [
          {
            id: 'press',
            title: 'common:navigation.media.press.title',
            type: 'menu',
            path: 'common:navigation.media.press.path',
            active: ['common:navigation.media.press.path'],
            permissions: [],
          },
          {
            id: 'album',
            title: 'common:navigation.media.album.title',
            type: 'menu',
            path: 'common:navigation.media.album.path',
            active: ['common:navigation.media.album.path'],
            permissions: [],
          },
        ],
        permissions: [],
      },
      {
        id: 'service',
        title: 'common:navigation.service.title',
        type: 'menu',
        path: '',
        active: [
          'common:navigation.service.report.path',
          'common:navigation.service.promotional.path',
          'common:navigation.service.jdih.path',
          'common:navigation.service.ppid.path',
          'common:navigation.service.careers.path',
        ],
        children: [
          {
            id: 'report',
            title: 'common:navigation.service.report.title',
            type: 'menu',
            path: 'common:navigation.service.report.path',
            active: ['common:navigation.service.report.path'],
            permissions: [],
          },
          {
            id: 'promotional',
            title: 'common:navigation.service.promotional.title',
            type: 'menu',
            path: 'common:navigation.service.promotional.path',
            active: ['common:navigation.service.promotional.path'],
            permissions: [],
          },
          {
            id: 'jdih',
            title: 'common:navigation.service.jdih.title',
            type: 'menu',
            path: 'common:navigation.service.jdih.path',
            active: ['common:navigation.service.jdih.path'],
            permissions: [],
          },
          // {
          //   id: 'ppid',
          //   title: 'common:navigation.service.ppid.title',
          //   type: 'menu',
          //   path: 'common:navigation.service.ppid.path',
          //   active: ['common:navigation.service.ppid.path'],
          //   permissions: [],
          // },
          // {
          //   id: 'careers',
          //   title: 'common:navigation.service.careers.title',
          //   type: 'menu',
          //   path: 'common:navigation.service.careers.path',
          //   active: ['common:navigation.service.careers.path'],
          //   permissions: [],
          // },
        ],
        permissions: [],
      },
    ],
    permissions: [],
  },
]
